<template>
  <div class="teacher-app-page grade-year-page">
    <Toolbar />

    <v-container class="grade-year-page__content" fluid>
      <header class="grade-year-heading">
        <div><p class="teacher-page-eyebrow">Report cards</p><h1>Enter student grades</h1><p>Start by choosing the academic year.</p></div>
      </header>

      <section class="grade-year-context" v-if="getClassRoom && getClassRoom.ClassRoom">
        <span><v-icon color="#2f7d4a">mdi-google-classroom</v-icon></span>
        <div><small>Current class</small><strong>{{ getClassRoom.ClassRoom.name }}</strong></div>
        <em>Grades</em>
      </section>

      <section class="grade-year-card">
        <div class="teacher-section-heading">
          <div><h2>Academic year</h2><p>Select a year to continue to terms and students.</p></div>
          <span v-if="years.length" class="grade-year-count">{{ years.length }}</span>
        </div>
        <div v-if="loading" class="teacher-loading-state"><v-progress-circular size="38" width="3" color="primary" indeterminate /><strong>Loading academic years</strong></div>
        <div v-else-if="years.length" class="grade-year-list">
          <button v-for="item in years" :key="item.id || item.name" type="button" @click="openGradeDetails(item)">
            <span><v-icon color="#3c6e9c">mdi-calendar-blank-outline</v-icon></span>
            <span><strong>{{ item.name }}</strong><small>Choose terms and enter grades</small></span>
            <v-icon size="19" color="#96a29a">mdi-chevron-right</v-icon>
          </button>
        </div>
        <div v-else class="grade-setup-empty">
          <span><v-icon size="30" color="#8a6525">mdi-calendar-alert-outline</v-icon></span>
          <h3>No academic years available</h3>
          <p>Administration must create an academic year before teachers can enter grades.</p>
          <small>Contact your administrator to finish report-card setup.</small>
        </div>
      </section>
    </v-container>
    <BottomNavigation />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import yearService from "@/modules/Year/service.js";
import Toolbar from "@/modules/Layout/components/Toolbar.vue";
import BottomNavigation from "@/modules/Layout/components/BottomNavigation.vue";

export default {
  name: "year-list",
  components: { BottomNavigation, Toolbar },
  data() {
    return { years: [], loading: true };
  },
  created() {
    if (!this.getClassRoom) this.$router.push({ path: "/" });
    else {
      document.title = "taleem - Enter Grades";
      this.getList();
    }
  },
  computed: { ...mapGetters("teacherLayout", ["getClassRoom"]) },
  methods: {
    getList() {
      if (!this.getClassRoom.ClassRoom || !this.getClassRoom.ClassRoom.ClassId) return;
      this.loading = true;
      return yearService.getAll({ ClassId: this.getClassRoom.ClassRoom.ClassId })
        .then(response => {
          this.years = response.data || [];
          return response;
        })
        .catch(() => { this.years = []; })
        .finally(() => { this.loading = false; });
    },
    openGradeDetails(year) {
      this.$router.push({ name: "grade-entry", params: { yearId: year.id } });
    },
  },
};
</script>
